// Matches markdown links [text](url), allowing escaped text delimiters, one level of balanced
// parentheses in URLs, and backslash-escaped title/URL delimiters such as \), \(, and \".
// e.g., [Wikipedia](https://en.wikipedia.org/wiki/File_(computing))
export const MARKDOWN_LINK_REGEX = /\[((?:\\.|[^\]\\])+)\]\(((?:\\.|\((?:\\.|[^()])*\)|[^()])*)\)/g;
export const escapeMarkdownLinkText = (text) => text.replace(/[\\[\]()]/g, '\\$&');
export const unescapeMarkdownLinkText = (text) => text.replace(/\\([\\[\]()])/g, '$1');
function getFencedCodeRanges(markdown) {
    const ranges = [];
    const lines = /[^\n]*(?:\n|$)/g;
    let openFence = null;
    for (const match of markdown.matchAll(lines)) {
        const line = match[0];
        if (!line || match.index == null)
            continue;
        const lineStart = match.index;
        const lineEnd = lineStart + line.length;
        const content = line.endsWith('\n') ? line.slice(0, -1) : line;
        if (openFence) {
            const closing = /^ {0,3}(`+|~+)[ \t]*$/.exec(content)?.[1];
            if (closing?.[0] === openFence.character && closing.length >= openFence.length) {
                ranges.push({ start: openFence.start, end: lineEnd });
                openFence = null;
            }
            continue;
        }
        const opening = /^ {0,3}(`{3,}|~{3,})(.*)$/.exec(content);
        const fence = opening?.[1];
        if (!fence || (fence[0] === '`' && opening?.[2]?.includes('`')))
            continue;
        openFence = { character: fence[0] ?? '', length: fence.length, start: lineStart };
    }
    if (openFence)
        ranges.push({ start: openFence.start, end: markdown.length });
    return ranges;
}
function isEscaped(markdown, index) {
    let backslashCount = 0;
    for (let cursor = index - 1; cursor >= 0 && markdown[cursor] === '\\'; cursor -= 1) {
        backslashCount += 1;
    }
    return backslashCount % 2 === 1;
}
function getInlineCodeRanges(markdown, start, end) {
    const ranges = [];
    let index = start;
    while (index < end) {
        if (markdown[index] !== '`' || isEscaped(markdown, index)) {
            index += 1;
            continue;
        }
        let delimiterLength = 1;
        while (markdown[index + delimiterLength] === '`')
            delimiterLength += 1;
        let cursor = index + delimiterLength;
        let closingEnd = null;
        while (cursor < end) {
            if (markdown[cursor] !== '`' || isEscaped(markdown, cursor)) {
                cursor += 1;
                continue;
            }
            let closingLength = 1;
            while (markdown[cursor + closingLength] === '`')
                closingLength += 1;
            if (closingLength === delimiterLength) {
                closingEnd = cursor + closingLength;
                break;
            }
            cursor += closingLength;
        }
        if (closingEnd === null) {
            index += delimiterLength;
            continue;
        }
        ranges.push({ start: index, end: closingEnd });
        index = closingEnd;
    }
    return ranges;
}
export function getMarkdownCodeRanges(markdown) {
    const fencedRanges = getFencedCodeRanges(markdown);
    const ranges = [];
    let cursor = 0;
    for (const fencedRange of fencedRanges) {
        ranges.push(...getInlineCodeRanges(markdown, cursor, fencedRange.start));
        ranges.push(fencedRange);
        cursor = fencedRange.end;
    }
    ranges.push(...getInlineCodeRanges(markdown, cursor, markdown.length));
    return ranges;
}
export const stripMarkdownLinkFormatting = (title) => {
    if (!title) {
        return '';
    }
    return title.replace(MARKDOWN_LINK_REGEX, (_match, text) => unescapeMarkdownLinkText(text));
};
//# sourceMappingURL=markdownTitle.js.map